import { ID } from '@griply/types';

export const getTaskIdFromTreeId = (id: ID): ID => {
  const idStr = id.toString();
  if (idStr.startsWith('occurrence:')) {
    const parts = idStr.split(':');
    return parts[2];
  }
  return id;
};
